import type { ComplianceResultStatus } from '#backend/entity/loaded/compliance/StatusConformidade';
import type { FilterFieldConfig } from '../../../shared/components/datasafra-search-reports/datasafra-search-reports.component';
import { ComplianceReportsFilters } from '../../../shared/types/compliances-report.types';

export function filterConfig(): FilterFieldConfig<ComplianceReportsFilters>[] {
  return [
    {
      key: 'organizationId',
      label: 'Cliente',
      type: 'autocomplete-org',
      adminOnly: true,
    },
    {
      key: 'requester',
      label: 'Solicitante',
      type: 'text',
      adminOnly: false,
    },
    {
      key: 'areaIdentification',
      label: 'Identificação da Área',
      type: 'text',
    },
    {
      key: 'state',
      label: 'UF',
      type: 'select',
    },
    {
      key: 'city',
      label: 'Município',
      type: 'select',
    },
    {
      key: 'cpfCnpj',
      label: 'CPF/CNPJ',
      type: 'text',
    },
    {
      key: 'car',
      label: 'CAR',
      type: 'text',
    },
    {
      key: 'producer',
      label: 'Produtor',
      type: 'text',
    },
    {
      key: 'contract',
      label: 'Contrato',
      type: 'text',
    },
    {
      key: 'insurancePolicy',
      label: 'Apólice',
      type: 'text',
    },
    {
      key: 'farmName',
      label: 'Nome da Fazenda',
      type: 'text',
    },
    {
      key: 'areaStatus',
      label: 'Situação',
      type: 'checkbox-group',
      options: [
        {
          value: 'compliant',
          label: 'Conforme',
        },
        {
          value: 'compliantWithObservations',
          label: 'Conforme com Ressalvas',
        },
        {
          value: 'nonCompliant',
          label: 'Não Conforme',
        },
        {
          value: 'notAnalyzed',
          label: 'Não Analisado',
        },
      ] satisfies {
        value: keyof NonNullable<ComplianceReportsFilters['areaStatus']>;
        label: string;
      }[],
    },
    {
      key: 'requestDate',
      label: 'Data da Solicitação',
      type: 'date-range',
    },
  ];
}
